import { OrderManagementPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import DashboardIcon from "@redotech/redo-icons/dashboard.svg";
import DashboardFilledIcon from "@redotech/redo-icons/dashboard_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import { OrderManagementSuiteStatusesContext } from "../../../../redo-suite/order-management-cloud";

export const DashboardItem = memo(function DashboardItem() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const { omsEnabled } = useContext(OrderManagementSuiteStatusesContext);

  const hasPermissionToViewDashboard = useHasPermission(
    OrderManagementPermissions.VIEW_ORDER_FULFILLMENT_ANALYTICS,
  );

  if (!omsEnabled || !hasPermissionToViewDashboard) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getOrdersOutboundLabelsSubRoute("dashboard"),
      }}
      FilledIcon={DashboardFilledIcon}
      friendlyName={t("Dashboard", {
        context:
          "order, fulfillment, claims, and warehouse operations navigation label",
      })}
      id="operations-dashboard"
      UnfilledIcon={DashboardIcon}
    />
  );
});
